import api from '../utils/api';

const recycleBinService = {
  // Get recycle bin items
  getRecycleBinItems: async (dataroomUuid, params = {}) => {
    try {
      const queryParams = new URLSearchParams({
        per_page: params.per_page || 20,
        page: params.page || 1,
        type: params.type || 'file',
        search: params.search || ''
      });

      // Add folder_uuid if provided to filter by folder
      if (params.folder_uuid) {
        queryParams.append('folder_uuid', params.folder_uuid);
      }

      // Add sorting parameters
      if (params.sort_by) {
        queryParams.append('sort_by', params.sort_by);
      }
      if (params.sort_order) {
        queryParams.append('sort_order', params.sort_order);
      }

      const response = await api.get(`/datarooms/${dataroomUuid}/files/recycle-bin?${queryParams}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching recycle bin items:', error);
      throw error;
    }
  },

  // Restore file from recycle bin (single file)
  restoreFile: async (dataroomUuid, fileUuid) => {
    try {
      // Use bulk restore endpoint with single UUID
      const response = await api.post(`/datarooms/${dataroomUuid}/files/restore`, {
        uuids: [fileUuid]
      });
      return response.data;
    } catch (error) {
      console.error('Error restoring file:', error);
      throw error;
    }
  },

  // Restore multiple files using bulk endpoint
  restoreMultipleFiles: async (dataroomUuid, fileUuids) => {
    try {
      const response = await api.post(`/datarooms/${dataroomUuid}/files/restore`, {
        uuids: fileUuids
      });

      // Return response in expected format
      return {
        successful: response.data,
        failed: [],
        totalRestored: fileUuids.length,
        totalFailed: 0
      };
    } catch (error) {
      console.error('Error restoring multiple files:', error);

      // If bulk restore fails, return error format
      return {
        successful: [],
        failed: fileUuids.map(uuid => ({ uuid, error: error.message })),
        totalRestored: 0,
        totalFailed: fileUuids.length
      };
    }
  },

  // Permanently delete file (if API exists)
  permanentlyDelete: async (dataroomUuid, fileUuid) => {
    try {
      const response = await api.delete(`/datarooms/${dataroomUuid}/files/${fileUuid}/permanent`);
      return response.data;
    } catch (error) {
      console.error('Error permanently deleting file:', error);
      throw error;
    }
  },

  // Empty recycle bin (if API exists)
  emptyRecycleBin: async (dataroomUuid) => {
    try {
      const response = await api.delete(`/datarooms/${dataroomUuid}/files/recycle-bin/empty`);
      return response.data;
    } catch (error) {
      console.error('Error emptying recycle bin:', error);
      throw error;
    }
  }
};

export default recycleBinService;